import {
  FormModal,
  FormModalType,
  InputField,
  MultiSelectInputField,
  Option,
  useToast,
  noop,
} from '@chillibean/component-library';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { useStudyProtocolModal } from '../../../../hooks';
import { StudyProcedureTaskDefinition } from '../../../../models';
import {
  addStudyProcedureTaskDefinition,
  modifyStudyProcedureTaskDefinition,
  removeStudyProcedureTaskDefinition,
} from '../../../../redux/actions';

export function StudyProcedureTaskDefinitionModal(props) {
  const { onClose = noop, onSuccess = noop, studyProcedureTaskDefinition = undefined, visible = false } = props;

  // VARIABLES
  const defaultValues = {
    displayName: studyProcedureTaskDefinition?.displayName,
    roleIds: studyProcedureTaskDefinition?.roleIds || [],
  };

  // HOOKS
  // Store
  const dispatch = useDispatch();
  const { data: protocol } = useSelector((state) => state.protocolReducer.protocol);
  const { data: roles } = useSelector((state) => state.rolesReducer.roles);
  const { error: actionError, loading } = useSelector((state) => state.protocolReducer.protocolAction);
  // Custom
  const { getCustomErrors, onCloseHandler } = useStudyProtocolModal({ onClose });
  const { showErrorToast, showSuccessToast } = useToast();

  const fields = [
    new InputField({
      disabled: loading,
      id: 'displayName',
      label: 'Name',
      maxLength: 250,
      name: 'Name',
      required: true,
      value: defaultValues.displayName,
    }),
    new MultiSelectInputField({
      disabled: loading,
      id: 'roleIds',
      label: 'Roles',
      name: 'Roles',
      options: roles.map((role) => new Option(role.name, role.id)),
      required: false,
      value: defaultValues.roleIds,
    }),
  ];

  // METHODS
  const onCreate = (data) => {
    dispatch(
      addStudyProcedureTaskDefinition({
        onError: showErrorToast,
        onSuccess: () => {
          showSuccessToast('Task Definition created successfully');
          onSuccess();
        },
        protocolId: protocol.id,
        studyProcedureTaskDefinitionData: data,
      }),
    );
  };

  const onUpdate = (data) => {
    dispatch(
      modifyStudyProcedureTaskDefinition({
        id: studyProcedureTaskDefinition.id,
        onError: showErrorToast,
        onSuccess: () => {
          showSuccessToast('Task Definition updated successfully');
          onSuccess();
        },
        protocolId: protocol.id,
        studyProcedureTaskDefinitionData: data,
      }),
    );
  };

  const onDelete = () => {
    dispatch(
      removeStudyProcedureTaskDefinition({
        id: studyProcedureTaskDefinition.id,
        onError: showErrorToast,
        onSuccess: () => {
          showSuccessToast('Task Definition removed successfully');
          onSuccess();
        },
        protocolId: protocol?.id,
      }),
    );
  };

  return (
    <FormModal
      customErrors={getCustomErrors(actionError)}
      defaultValues={defaultValues}
      deletable={Boolean(studyProcedureTaskDefinition)}
      fields={fields}
      loading={loading}
      onClose={onCloseHandler}
      onCreate={onCreate}
      onDelete={onDelete}
      onUpdate={onUpdate}
      title={studyProcedureTaskDefinition ? 'Update Task Definition' : 'Add Task Definition'}
      type={studyProcedureTaskDefinition ? FormModalType.UPDATE : FormModalType.CREATE}
      visible={visible}
    />
  );
}

StudyProcedureTaskDefinitionModal.propTypes = {
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  studyProcedureTaskDefinition: PropTypes.instanceOf(StudyProcedureTaskDefinition),
  visible: PropTypes.bool,
};

export default StudyProcedureTaskDefinitionModal;
